'use client';

import { AppContextProvider } from '@/components/app-context';
import { AuthUnauthorizedInterceptor } from '@/components/auth-unauthorized-interceptor';
import { LanguageProvider } from '@/components/language-provider';
import { ThemeProvider } from '@/components/theme-provider';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthUnauthorizedInterceptor />
        <AppContextProvider>{children}</AppContextProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}
